import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import * as React from "react";

import { useMessagePathById } from "@/shared/domain/topics/hooks/useMessagePath";
import { useTopicById } from "@/shared/domain/topics/hooks/useTopic";
import { LoggerService } from "@/shared/services/LoggerService";

import { MessagePathLink } from "./MessagePathLink";

interface MessagePathLinkFromIdProps {
  messagePathId: string;

  /**
   * If provided, the file will be opened at the given time.
   * Otherwise, the file will be opened at the start of the file.
   *
   * `startTime` is in nanoseconds since the UNIX epoch.
   **/
  startTime?: bigint;
}

export const MessagePathLinkFromId: React.FC<MessagePathLinkFromIdProps> = ({
  messagePathId,
  startTime,
}) => {
  const mpQuery = useMessagePathById(messagePathId);
  const topicQuery = useTopicById(mpQuery.data?.topic_id);

  if (mpQuery.isPending || topicQuery.isPending) {
    return (
      <Typography variant="body2">
        <Skeleton variant="text" width="200px" />
      </Typography>
    );
  }

  if (mpQuery.isError || topicQuery.isError) {
    if (mpQuery.isError) {
      LoggerService.error(mpQuery.error?.message, mpQuery.error);
    }

    if (topicQuery.isError) {
      LoggerService.error(topicQuery.error?.message, topicQuery.error);
    }
    return (
      <Typography variant="body2" color="error">
        Failed to load link
      </Typography>
    );
  }

  return (
    <MessagePathLink
      messagePath={mpQuery.data}
      topic={topicQuery.data}
      topicAssociation={topicQuery.data.association}
      linkPrefix={`${topicQuery.data.topic_name}.`}
      startTime={startTime}
    />
  );
};
